import { RadioV2 } from "#src/commonV2/inputs/Radio";
import { ArrowNarrowUpRight } from "@untitled-ui/icons-react";
import { ReactNode, SVGProps } from "react";
import { useTranslation } from "react-i18next";

interface IBackupStorageItemProps {
  enabled: boolean;
  Icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  title: string;
  hint: string;
  comingSoon?: boolean;
  onClickConfig?: () => void;
}

export const BackupStorageItem = ({
  enabled,
  Icon,
  title,
  hint,
  comingSoon,
  onClickConfig,
}: IBackupStorageItemProps) => {
  const { t } = useTranslation("endpoint", {
    keyPrefix: "dlp.backupSettings.backupStorage",
  });

  return (
    <div
      className={`p-4 flex gap-4 border ${enabled ? "border-brand-v2-300 bg-brand-v2-50" : "border-gray-v2-200"} ${comingSoon ? "opacity-50" : ""} rounded-lg`}
    >
      <div
        className={`h-7 flex items-center ${comingSoon ? "pointer-events-none" : ""}`}
      >
        <RadioV2 checked={enabled} onClick={onClickConfig} />
      </div>
      <div className="flex flex-col gap-1.5 flex-1">
        <div className="flex gap-4 items-center justify-between">
          <div className="flex gap-2">
            <Icon className="h-6 w-6 min-w-6 text-gray-v2" />
            <span className="text-md font-semibold text-gray-v2-900">
              {title}
            </span>
            {comingSoon ? (
              <span className="text-md italic text-brand-v2-600">
                {t("comingSoon")}
              </span>
            ) : null}
          </div>
          {comingSoon || !onClickConfig ? null : (
            <button
              className="flex gap-1 text-sm font-semibold text-brand-v2-700"
              onClick={onClickConfig}
            >
              {t("configure")}
              <ArrowNarrowUpRight className="h-5 w-5 min-w-5 text-brand-v2-700" />
            </button>
          )}
        </div>
        <div className="text-md text-gray-v2-600">{hint}</div>
      </div>
    </div>
  );
};
